module.exports = __webpack_public_path__ + "static/media/fees-eth.7e2f5589.svg";